import { DiamondStencil } from "../../../core";

/**
 * Decision Flowchart stencil.
 */
export class DecisionStencil extends DiamondStencil {
  public static typeName = 'DecisionStencil';
}
